export namespace HistoryConstants {
  export const usedPlace = ["", 'Fast Lane', 'KIXラウンジ', 'ITMラウンジ', 'UKBラウンジ'];
  export const flightClass = [
    "",
    'エコノミークラス',
    'プレミアムエコノミークラス',
    'ビジネスクラス',
    'ファーストクラス'
  ];
  export const useLounge = [
    "",
    'ラウンジオーサカ',
    'ラウンジ神戸'
  ]
}
